/**
 * walleu-gallery-snap-fix
 * Safari/WebKit snaps the product-gallery media-carousel to a random slide during
 * the initial page layout (scroll-snap re-snap while loading; reproduced 5/8 cold
 * loads on iPhone WebKit — lands on any slide, often the last). The vendor carousel
 * only corrects itself when initial-index != 0: for index 0 it marks the slide
 * selected without scrolling (BaseCarousel.connectedCallback), so single-variant
 * products with no variant image open on a random photo.
 *
 * Fix: shortly after init (and on bfcache restore), if the carousel sits away from
 * its selected slide and the user hasn't touched it yet, scroll it back. Instant
 * (no smooth) so at worst it's an imperceptible correction during load.
 */
(function () {
  'use strict';

  // The gallery snippet is rendered by main-product and featured-product; guard
  // against the script tag being emitted (and executed) more than once.
  if (window.__walleuGallerySnapFix) return;
  window.__walleuGallerySnapFix = true;

  var touched = new WeakSet();

  function markTouched(event) {
    var carousel = event.target.closest && event.target.closest('media-carousel');
    if (carousel) touched.add(carousel);
  }
  // Any real interaction with the carousel disarms the fix for it.
  ['touchstart', 'pointerdown', 'wheel'].forEach(function (type) {
    document.addEventListener(type, markTouched, { capture: true, passive: true });
  });

  function expectedScrollLeft(carousel, slide) {
    // Mirrors the vendor's "center" alignment math (_transitionTo).
    var align = getComputedStyle(slide).scrollSnapAlign === 'center' ? 'center' : 'start';
    if (align === 'center') {
      var padding = parseInt(getComputedStyle(carousel).scrollPaddingInline, 10) || 0;
      return slide.offsetLeft - (carousel.clientWidth / 2 - padding) + slide.clientWidth / 2;
    }
    return slide.offsetLeft;
  }

  function correct() {
    document.querySelectorAll('media-carousel').forEach(function (carousel) {
      if (touched.has(carousel)) return;
      if (!carousel.offsetParent || carousel.scrollWidth <= carousel.clientWidth) return;
      var slide = carousel.querySelector('.is-selected') || carousel.firstElementChild;
      if (!slide || slide.hidden) return;
      var target = Math.max(0, Math.round(expectedScrollLeft(carousel, slide)));
      if (Math.abs(carousel.scrollLeft - target) > 2) {
        carousel.scrollTo({ left: target, behavior: 'auto' });
      }
    });
  }

  // The phantom snap happens before `load`; re-check a few times to cover slow
  // custom-element upgrade, then once more on bfcache restores.
  function schedule() {
    correct();
    setTimeout(correct, 250);
    setTimeout(correct, 1000);
    setTimeout(correct, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', correct);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) schedule();
  });
})();
